import { render } from "./StepPrezzi.vue?vue&type=template&id=56496e0c&scoped=true"
import script from "./StepPrezzi.vue?vue&type=script&lang=js"
export * from "./StepPrezzi.vue?vue&type=script&lang=js"

import "./StepPrezzi.vue?vue&type=style&index=0&id=56496e0c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56496e0c"]])

export default __exports__